export const environment = {
    production: false,
    environmentName: 'development',
    apiUrl: '',
    debugMode: true,
    enableLogs: true, // Disable console logs for production environment
    featureFlags: {
        enableAnalytics: true,
        enableExperimentalFeatures: false
    },
    services: {
        auth: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/auth/v1',
            auth0ClientId: 'B0tkaimqN7BCi7NhksPowIqj0N41t44L',
            auth0Domain: 'hundredxinc-development.auth0.com',
            auth0AudienceDomain: 'hundredxinc-development.auth0.com',
            auth0CallbackURL: 'http://localhost:4100/login?callback=true',
            federatedSignout: true
        },
        firebaseToken: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/auth/v1/firebase/token'
        },
        account: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/account/v1'
        },
        contact: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/contact/v1'
        },
        feedback: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/feedback/v1'
        },
        participant: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/participant/v1'
        },
        transaction: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/transaction/v1'
        },
        solution: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/solution/v1',
            efgAccountId: 1017 // Needs to be updated once one is made
        },
        cbreService: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/cbre/v1'
        },
        reporting: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/reporting/v1'
        },
        data: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/data/v1'
        },
        regionSync: {
            baseUrl: 'http://localhost:3000',
            basePath: ''
        },
        masterData: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/master-data/v1'
        },
        plc: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/plc/v1'
        }
    }
};